import React, { useContext } from "react";
import { ProcedureType, TScreen, UploadTypeType } from "api/type";

// Import Contexts
import ScreenContext from "contexts/screen";

// Import Components
import {
  SelectModel,
  NormalText,
  PoweredByClinicOS,
  TitleBar,
} from "components/index";

// Import Constants and Utils
import {
  breastAugModels,
  breastLiftModels,
  breastLiftAndAugModels,
  breastReductionModels,
  tummyTuckModels,
  bblModels,
  lipFillerModels,
} from "api/constants";
import { formatProcedureName } from "utils/formatProcedureName";

type ScreenSelectModelProps = {
  selectedProcedure: ProcedureType | null;
  handleSaveImageUrlOrBlob: (imageUrlOrBlob: string | Blob) => void;
  handleSetUploadType: (uploadType: UploadTypeType) => void;
};

const ScreenSelectModel: React.FC<ScreenSelectModelProps> = ({
  selectedProcedure,
  handleSaveImageUrlOrBlob,
  handleSetUploadType,
}) => {
  // Context
  const setScreen = useContext(ScreenContext)[1];

  const renderImagePicker = () => {
    let models: string[] = [];
    if (selectedProcedure === ProcedureType.BREAST_AUGMENTATION) {
      models = breastAugModels;
    } else if (selectedProcedure === ProcedureType.BREAST_REDUCTION) {
      models = breastReductionModels;
    } else if (selectedProcedure === ProcedureType.BREAST_LIFT) {
      models = breastLiftModels;
    } else if (selectedProcedure === ProcedureType.TUMMY_TUCK) {
      models = tummyTuckModels;
    } else if (selectedProcedure === ProcedureType.BBL) {
      models = bblModels;
    } else if (selectedProcedure === ProcedureType.LIP_FILLER) {
      models = lipFillerModels;
    } else if (
      selectedProcedure === ProcedureType.BREAST_LIFT_AND_AUGMENTATION
    ) {
      models = breastLiftAndAugModels;
    }

    return (
      <SelectModel
        imageUrls={models.map((modelUrl: string) => modelUrl)}
        allowUpload={false}
        allowUploadSetScreen={() => {
          setScreen(TScreen.SELECT_UPLOAD_TYPE_SCREEN);
        }}
        handleSaveImageUrlOrBlob={(imageUrlOrBlob: string | Blob) => {
          handleSaveImageUrlOrBlob(imageUrlOrBlob);
          setScreen(TScreen.SIMULATION_VIEW_SCREEN);
          handleSetUploadType(UploadTypeType.MODEL);
        }}
      />
    );
  };

  return (
    <div className="screen-container">
      <TitleBar
        name={`Visualize a ${formatProcedureName(selectedProcedure, true)}`}
        onClickBackButton={() => setScreen(TScreen.SELECT_PROCEDURE_SCREEN)}
      />
      <NormalText
        textContent={`Visualize a ${formatProcedureName(
          selectedProcedure,
        )} on a model below`}
      />
      <div style={styles.imagePickerContainer}>{renderImagePicker()}</div>
      <PoweredByClinicOS />
    </div>
  );
};

const styles = {
  imagePickerContainer: {
    overflow: "auto" as const,
    marginBottom: "auto",
    boxSizing: "border-box" as const,
    width: "100%",
  },
} as const;

export default ScreenSelectModel;
